import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "src/App.tsx"
import { store } from "src/shared/store/store.ts"
import { Provider } from "react-redux"
import { CssBaseline } from "@mui/material"
import GlobalStyle from "src/shared/css/global-style"
import { ThemeContextProvider } from "src/shared/context/theme-context"
import "./shared/css/global.css"
import { GlobalConfigProvider } from "src/shared/context/globalConfigContext"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { ApolloProvider } from "@apollo/client"
import apolloClient from "./apollo/client"
import ToastifyAlert from "./shared/container/toastify-alert"
import ErrorBoundary from "./modules/error/error-baundary"
import "react-international-phone/style.css"
import "./i18n/config"
// document.body.dir = "rtl"
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <Provider store={store}>
          <GlobalConfigProvider>
            <ThemeContextProvider>
              <ToastifyAlert />
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <CssBaseline />
                <GlobalStyle />
                <App />
              </LocalizationProvider>
            </ThemeContextProvider>
          </GlobalConfigProvider>
        </Provider>
      </ApolloProvider>
    </ErrorBoundary>
  </StrictMode>
)
